import { NotificationManager } from "react-notifications";

export function handleSaveSuccess() {
    const { saveDnsProviderError, savedDnsProvider } = this.props;
    if (saveDnsProviderError) {
        NotificationManager.error(saveDnsProviderError, "Save DNS Provider Config", 3000);
    }
    else {
        NotificationManager.success("DNS Provider Config Saved", "Successfully Saved DNS Provider Config");
        if (this.props.inline || this.props.wizard || this.state.wizard) {
            this.setState({ dns_provider_config: savedDnsProvider })
            this.nextPage() 
        } else {
            this.props.history.push("/dns_provider");
        }
    }
}

export function handleSaveError() {
    const { saveDnsProviderError } = this.props;
    if (saveDnsProviderError) {
        NotificationManager.error(saveDnsProviderError, "Save DNS Provider Config", 3000);
    } else
        NotificationManager.error("Save DNS Provider Config Failed", "Save DNS Provider Config", 3000);
}
